var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmployee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 8.5,
    fill: "#3792E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 23.1684C35.0383 21.992 36.5575 21.25 38.25 21.25C41.3796 21.25 43.9167 23.7871 43.9167 26.9167C43.9167 30.0463 41.3796 32.5833 38.25 32.5833C36.5575 32.5833 35.0383 31.8413 34 30.6649M38.25 46.75H21.25V45.3333C21.25 40.6389 25.0556 36.8333 29.75 36.8333C34.4444 36.8333 38.25 40.6389 38.25 45.3333V46.75ZM38.25 46.75H46.75V45.3333C46.75 40.6389 42.9444 36.8333 38.25 36.8333C36.7018 36.8333 35.2502 37.2473 34 37.9705M35.4167 26.9167C35.4167 30.0463 32.8796 32.5833 29.75 32.5833C26.6204 32.5833 24.0833 30.0463 24.0833 26.9167C24.0833 23.7871 26.6204 21.25 29.75 21.25C32.8796 21.25 35.4167 23.7871 35.4167 26.9167Z",
    stroke: "white",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee);
export default __webpack_public_path__ + "static/media/employee.9efff03323e04ccaa3a6ffefe8b85d80.svg";
export { ForwardRef as ReactComponent };